document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('.home-hero');

    if (hero) {
        console.log('Home Hero block initialized');
        // Dodaj animacje, eventy itp.
    }
});
